module.exports = __webpack_public_path__ + "img/Z60Q_09.8d6aedfa.jpg";